import page from "page";
import { map } from "./router";

import dayjs from "dayjs";
import "./ext";
import accountIndex from "./pages/account";
import adminAccounts from "./pages/admin/accounts";
import viewAdminAccount from "./pages/admin/accounts/[accountId]";
import adminAccountRateLimits from "./pages/admin/accounts/rate-limits";
import login from "./pages/auth/login";
import loginHelp from "./pages/auth/help";
import recoverLogin from "./pages/auth/recover";
import recoverSignIn from "./pages/auth/recover-sign-in";
import recoverReset from "./pages/auth/recover-reset";
import oauthAuthorize from "./pages/auth/oauth-authorize";
import listChatClients from "./pages/chat-clients";
import viewChatClient from "./pages/chat-clients/[id]";
import chatClientChat from "./pages/chat-clients/chat";
import telegram from "./pages/chat-clients/integrations/telegram";
import zApi from "./pages/chat-clients/integrations/z-api";
import evolutionApi from "./pages/chat-clients/integrations/evolution-api";
import kapso from "./pages/chat-clients/integrations/kapso";
import collections from "./pages/collections";
import collectionDocumentsIndex from "./pages/collections/documents";
import viewCollectionDocument from "./pages/collections/documents/[id]";
import collectionPlayground from "./pages/collections/playground";
import conversations from "./pages/conversations";
import viewConversation from "./pages/conversations/[id]";
import skills from "./pages/skills";
import viewSkill from "./pages/skills/[id]";
import dashboard from "./pages/dashboard";
import functionPlayground from "./pages/functions/playground";
import listGateways from "./pages/gateways";
import viewGateway from "./pages/gateways/[id]";
import pageIndex from "./pages/index";
import logsIndex from "./pages/logs";
import miniapp from "./pages/miniapp";
import usageIndex from "./pages/usage/index";
import analyticsIndex from "./pages/analytics/index";
import SysinsBuilder from "./pages/tools/sysins-builder";
import models from "./pages/models/index";
import plan from "./pages/account/plan";
import modelTiers from "./pages/model-tiers";
import batchIndex from "./pages/batch";
import batchWorkflow from "./pages/batch/[workflowId]";
import batchJob from "./pages/batch/jobs/[jobId]";
import generations from "./pages/generations";
import agenticTests from "./pages/tests";
import viewAgenticTest from "./pages/tests/[id]";
import viewAgenticTestRun from "./pages/tests/runs/[runId]";
import agenticTestsPlayground from "./pages/validations";
import voice from "./pages/voice";
import instructionStore from "./pages/instruction-store";
import "./prism-ext/spintax";

var relativeTime = require("dayjs/plugin/relativeTime");
var duration = require("dayjs/plugin/duration");
dayjs.extend(relativeTime);
dayjs.extend(duration)

map('/', pageIndex);
map('/login', login);
map('/login/help', loginHelp);
map('/login/help/recover', recoverLogin);
map('/login/recover/sign-in', recoverSignIn);
map('/login/recover/reset', recoverReset);
map('/oauth/authorize', oauthAuthorize);
map('/dashboard', dashboard);
map('/dashboard/plan', plan);
map('/dashboard/models', models);
map('/dashboard/collections', collections);
map('/dashboard/collections/:id', ctx => page.redirect(`/dashboard/collections/${ctx.params.id}/documents`));
map('/dashboard/collections/:id/playground', collectionPlayground);
map('/dashboard/collections/:id/documents', collectionDocumentsIndex);
map('/dashboard/collections/:id/documents/:documentid', viewCollectionDocument);
map('/dashboard/batch', batchIndex);
map('/dashboard/batch/workflows/:workflowId', batchWorkflow);
map('/dashboard/batch/workflows/:workflowId/jobs/:jobId', batchJob);
map('/dashboard/generations', generations);
map('/dashboard/tests', agenticTests);
map('/dashboard/tests/playground', agenticTestsPlayground);
map('/dashboard/tests/:id/runs/:runId', viewAgenticTestRun);
map('/dashboard/tests/:id', viewAgenticTest);
map('/dashboard/validations', ctx => page.redirect('/dashboard/tests/playground'));
map('/dashboard/voice', voice);
map('/dashboard/ai-gateways', listGateways);
map('/dashboard/gateways/:gatewayId', viewGateway);
map('/dashboard/chat-clients', listChatClients);
map('/dashboard/chat-clients/:id', viewChatClient);
map('/dashboard/chat-clients/:id/integrations/z-api', zApi);
map('/dashboard/chat-clients/:id/integrations/telegram', telegram);
map('/dashboard/chat-clients/:id/integrations/evolution-api', evolutionApi);
map('/dashboard/chat-clients/:id/integrations/kapso', kapso);
map('/dashboard/account', accountIndex);
map('/dashboard/admin/accounts', adminAccounts);
map('/dashboard/admin/accounts/:accountId', viewAdminAccount);
map('/dashboard/admin/accounts/:accountId/rate-limits', adminAccountRateLimits);
map('/dashboard/usage', usageIndex);
map('/dashboard/analytics', analyticsIndex);
map('/dashboard/logs', logsIndex);
map('/dashboard/instruction-store', instructionStore);
map('/dashboard/conversations', conversations);
map('/dashboard/conversations/:id', viewConversation);
map('/dashboard/skills/', skills);
map('/dashboard/skills/:id', viewSkill);
map('/dashboard/functions/playground', functionPlayground);
map('/dashboard/tools/sysin-builder', SysinsBuilder);
map('/miniapp', miniapp);
map('/model-tiers', modelTiers);

map('/chat/:key', chatClientChat);

document.addEventListener("DOMContentLoaded", () => {
    page();
});
window.addEventListener("resize", () => {
    document.querySelectorAll("[redrawable]").forEach(e => {
        if (e.redraw) {
            e.redraw();
        }
    });
})

// hover events
let dragCounter = 0;

document.addEventListener("dragenter", ev => {
    ev.preventDefault();
    dragCounter++;
    if (dragCounter === 1) {
        document.body.classList.add("dragging");
    }
});
document.addEventListener("dragleave", ev => {
    ev.preventDefault();
    dragCounter--;
    if (dragCounter === 0) {
        document.body.classList.remove("dragging");
    }
});
document.addEventListener("dragover", ev => {
    ev.preventDefault();
});
document.addEventListener("drop", ev => {
    ev.preventDefault();
    dragCounter = 0;
    document.body.classList.remove("dragging");
    if (window._dragHandler) {
        window._dragHandler(ev);
    }
});
